module.exports = __webpack_public_path__ + "assets/img/2.9c6f410d.jpg";